import React, {useEffect, useState} from 'react';
import {homework} from "./index";
import {useAppDispatch, useAppSelector} from "common/hook";
import {message, Select} from 'antd';
import {optionsStatus} from "./selector/options";
import {useFormik} from "formik";
import {useInputWithFocus} from "common/hook/useInputWithFocus";
import {ReactComponent as SelectArrayIcon} from '../../../../../../../../../../assets/i/select-array-icon.svg';
import {ReactComponent as ArrowUpIconIcon} from '../../../../../../../../../../assets/i/arrow-up-icon.svg';
import {ROLE_HR, ROLE_TEACHER} from "entities/constants/constants";
import {Link, useParams} from "react-router-dom";
import {
    updateHomeworkStatus
} from "features/model/service/homework/homework-status/fetchHomeWorkStatus";
import {
    fetchHomeworkAnswer
} from "features/model/service/homework/get-home-work/getHomeWork";
import {NothingYetMessage} from "components/pages/personal-cabinet/nothing-yet-message/NothingYetMessage";
import {Preloader} from "components/layout/preloader/Preloader";

export const HomeWorkContent = () => {
    const [open, setOpen] = useState<boolean>(false);
    const dispatch = useAppDispatch()
    const roleType = useAppSelector((state) => state.role.roleType);
    const homeworkData = useAppSelector(state => state.homeWorkTeacher);
    const {isLoading, data} = homeworkData;

    const groupId = data?.lesson?.groupId

    const {lessonsId, studentId} = useParams();


    const getStatusClassName = (status: string | null) => {
        switch (status) {
            case 'done':
                return '';
            case 'notDone':
                return 'not-done';
            case 'partiallyDone':
                return 'partially-done';
            case 'notAssigned':
                return 'not-assigned';
            case 'notVerified':
                return 'not-assigned';
            default:
                return '';
        }
    };

    const getStatusText = (status: string | null) => {
        switch (status) {
            case 'done':
                return 'Выполнено';
            case 'notDone':
                return 'Не выполнено';
            case 'partiallyDone':
                return 'Частично выполнено';
            case 'notAssigned':
                return 'Не сдано';
            case 'notVerified':
                return 'Не проверено';
            default:
                return '';
        }
    };

    const OnClickHandler = () => {
        setOpen(!open)
    }

    const success = () => {
        message.success('Статус успешно изменен');
    };

    const {
        handleFocus,
        handleBlur
    } = useInputWithFocus([false, false, false, false, false, false, false, false, false, false]);


    useEffect(() => {
        dispatch(fetchHomeworkAnswer({lessonsId, studentId}));
    }, [lessonsId, studentId]);


    const handleStatusChange = (newStatus: string) => {
        if (studentId !== undefined) {
            dispatch(updateHomeworkStatus({lessonsId, userId: studentId, status: newStatus}))
                .then(() => {
                    dispatch(fetchHomeworkAnswer({lessonsId, studentId}));
                    success();
                })
                .catch((error) => {
                    console.error('Error:', error);
                });
        } else {
            console.error('studentId is undefined');
        }
    };

    const handleChange = (field: string, value: string) => {
        formik.setFieldValue(field, value);
    };

    const handleSubmit = () => {
    };

    const formik = useFormik({
        initialValues: {
            status: '',
        },
        onSubmit: handleSubmit,
    });


    return (
        <div className="tabs-content">
            {isLoading ? (<Preloader/>) : (
                <div className="tab">
                    {data?.homework && (
                        <div className="details-data-box">
                            <div className="col">
                                <p className="col-title">Дата домашнего задания</p>
                                <time className="time">{data?.homework?.date}</time>
                            </div>
                            <div className="col">
                                <p className="col-title">Студент</p>
                                <p>
                                    <Link to={`/groups/${groupId}/students-pages/${data?.student?.id}`}>
                                        {data?.student?.fullName}
                                    </Link>
                                </p>
                            </div>
                            <div className="col">
                                <p className="col-title">Занятие</p>
                                <p>
                                    <Link to={`/lessons/${data?.lesson?.id}`}>
                                        {data?.lesson?.title}
                                    </Link>
                                </p>
                            </div>
                            <div className="col">
                                {roleType === ROLE_HR ? (
                                    <>
                                        <p className="col-title">Статус</p>
                                        <p className={`status-item ${getStatusClassName(data?.homeworkAnswer?.status)}`}>
                                            <span>{getStatusText(data?.homeworkAnswer?.status)}</span>
                                        </p>
                                    </>
                                ) : (
                                    <div className="field position">
                                        <div className="course-type" onClick={OnClickHandler}>
                                  <span
                                      className={data?.homeworkAnswer?.status || formik.values.status ? 'active-label' : ''}>
                                      Статус
                                  </span>
                                            {data?.homeworkAnswer?.status === 'notAssigned' ? (
                                                <Select
                                                    style={{width: '100%'}}
                                                    options={optionsStatus}
                                                    defaultValue='Не сдано'
                                                    disabled={true}
                                                    onChange={(value) => {
                                                        handleChange('status', value);
                                                        handleStatusChange(value);
                                                    }}
                                                    suffixIcon={<SelectArrayIcon/>}
                                                />
                                            ) : (
                                                <Select
                                                    style={{width: '100%'}}
                                                    options={optionsStatus}
                                                    value={data?.homeworkAnswer?.status || formik.values.status}
                                                    onFocus={() => handleFocus(0)}
                                                    onBlur={handleBlur}
                                                    disabled={data?.homeworkAnswer?.status === 'notAssigned' && true}
                                                    onChange={(value) => {
                                                        handleChange('status', value);
                                                        handleStatusChange(value);
                                                    }}
                                                    suffixIcon={open ? <ArrowUpIconIcon/> : <SelectArrayIcon/>}
                                                />
                                            )}
                                        </div>
                                    </div>

                                )}
                            </div>
                        </div>
                    )}

                    <div className="info-cards-box masonry-view">
                        <div className="info-card large  bg2">
                            <div className="info-card-hdr">
                                <div className="title-box">
                                    <p className="info-card-title h6">Описание домашнего задания</p>
                                </div>
                            </div>
                            <div className="info-card-content">
                                {data?.homework?.description && data.homework.description.length > 0 ? (
                                    <p>{data?.homework?.description}</p>
                                ) : (
                                    <NothingYetMessage/>
                                )}
                            </div>
                        </div>

                        <div className="info-card full-width-mobile bg2">
                            <div className="info-card-hdr">
                                <div className="title-box">
                                    <p className="info-card-title h6">Материалы домашнего задания</p>
                                </div>
                            </div>
                            <div className="info-card-content">
                                {data?.homework?.homeworkFiles && data.homework.homeworkFiles.length > 0 ? (
                                    <ul className="attached-files-list">
                                        {data?.homework?.homeworkFiles?.map((attachment, index) => (
                                            <li key={index}>
                                                <div className="file-name">
                                                    <a href={attachment.path} target="_blank"
                                                       rel="noopener noreferrer">
                                                        {attachment.fileName}
                                                    </a>
                                                </div>
                                                <span className="file-size">{attachment.fileSize}</span>
                                            </li>
                                        ))}
                                    </ul>
                                ) : (
                                    <NothingYetMessage/>
                                )}
                            </div>
                        </div>
                        <hr/>

                        {
                            (roleType === ROLE_TEACHER || roleType === ROLE_HR) && (
                                <>
                                    {data && data?.homeworkAnswer?.text ? (
                                        <div className="info-card large">
                                            <div className="info-card-hdr">
                                                <div className="title-box">
                                                    <p className="info-card-title h6">Ответ студента</p>
                                                </div>
                                            </div>
                                            <div className="info-card-content">
                                                <p>{data.homeworkAnswer.text}</p>
                                                <ul className="attached-files-list">
                                                    {data?.homeworkAnswer?.homeworkFiles?.map((attachment, index) => (
                                                        <li key={index}>
                                                            <div className="file-name">
                                                                <a href={attachment.path} target="_blank"
                                                                   rel="noopener noreferrer">
                                                                    {attachment.fileName}
                                                                </a>
                                                            </div>
                                                            <span className="file-size">{attachment.fileSize}</span>
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                        </div>
                                    ) : (
                                        <div className="info-card large">
                                            <div className="info-card-hdr">
                                                <div className="title-box">
                                                    <p className="info-card-title h6">{homework.hasResponse.title}</p>
                                                </div>
                                            </div>
                                            <div className="info-card-content">
                                                <p className="status-item no-answer">{homework.hasResponse.text}</p>
                                            </div>
                                        </div>
                                    )}
                                </>
                            )
                        }
                    </div>

                </div>
            )}
        </div>
    );
};

